var SaitoPhotoCropperTemplate = function SaitoPhotoCropperTemplate(app, mod, image) {
  return "\n\t\t<div class='saito-photo-cropper'>\n\t\t\t<div class=\"photo-cropper\"> \n\t\t\t\t<img id=\"imageToCrop\" src=\"".concat(image, "\">\n\t\t\t</div>\n\t\t\t<button id=\"cropButton\" class=\"saito-button-primary\">Crop Image</button>\n\t\t</div>");
};
module.exports = SaitoPhotoCropperTemplate;